import { Tooltip } from '@affine/component';
import { IntegrationService } from '@affine/core/modules/integration';
import type { GitHubRefMeta } from '@affine/core/modules/integration/type';
import { GithubIcon } from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { useMemo } from 'react';

export const GitHubIndicator = ({ docId }: { docId: string }) => {
  const integrationService = useService(IntegrationService);
  const github = integrationService.github;
  const settings = useLiveData(github.settings$);

  const ref = useMemo(() => {
    if (!settings?.accessToken) return null;
    return github.getDocIntegrationRef(docId);
  }, [github, docId, settings?.accessToken]);

  const refMeta = ref?.refMeta as GitHubRefMeta | undefined;

  if (!refMeta) return null;

  const lastSynced = refMeta.lastSyncedAt
    ? new Date(refMeta.lastSyncedAt).toLocaleDateString()
    : 'Never';
  const tooltip = `GitHub: ${refMeta.owner}/${refMeta.repo}/${refMeta.path}\nLast synced: ${lastSynced}`;

  return (
    <Tooltip content={tooltip}>
      <span style={{ display: 'flex', alignItems: 'center' }}>
        <GithubIcon style={{ fontSize: 14, flexShrink: 0, opacity: 0.6 }} />
      </span>
    </Tooltip>
  );
};
